import { CoordinatorService } from './coordinator.service';
import { ScriptAutoUser } from './script-auto-user';

export class ScriptAutoUserManager {
    #coords: CoordinatorService;

    constructor(coords: CoordinatorService) {
        this.#coords = coords;
    }

    create(nm: string) {
        const oldAU = this.get(nm);
        if (oldAU) {
            console.error(`AutoUser "${nm}" already exists.`);
            return null;
        }
        const au = this.get(nm, true);
        au!.toProject();
        return au;
    }

    get(nm: string, isCreate = false) {
        const au = this.#coords.autouser$.get(nm, isCreate);
        if (!au) return null;
        return new ScriptAutoUser(this.#coords, au);
    }

    list() {
        return this.#coords.autouser$.autouserLs.map((au) => new ScriptAutoUser(this.#coords, au));
    }

    deleteAll() {
        this.#coords.autouser$.autouserLs.forEach((au) => au.delete());
        this.#coords.display$.markForCheck();
        return this;
    }

    log(prefix = 'Autouser Manager') {
        console.log(prefix);
        console.log(this.list());
        return this;
    }

    display = this.log;
}
